import { render, staticRenderFns } from "./JsonEditorComponent.vue?vue&type=template&id=4fd9aed0&scoped=true&"
import script from "./JsonEditorComponent.vue?vue&type=script&lang=ts&"
export * from "./JsonEditorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./JsonEditorComponent.vue?vue&type=style&index=0&id=4fd9aed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd9aed0",
  null
  
)

export default component.exports